// src/store.js

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Replace with your actual reducers from the correct path
import { reducers } from "../reducers/index.jsx";

const persistConfig = {
  key: 'state',
  storage: storage,
  whitelist: ['auth', 'loader', 'projects', 'jobs'],
};

// You need to combine the reducers before passing them to the persistor
// If `reducers` is already a root reducer (a function), use it directly;
// otherwise, combine the reducers object into a root reducer.
const rootReducer =
  typeof reducers === 'function' ? reducers : combineReducers(reducers);

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Redux-persist dispatches non-serializable actions, so we must ignore them
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { persistor, store };